import React from 'react';
import {
  FontWeightType, HeadingLarge,
} from '../../../component/Text';
import { FadeInDirectionType, FadeWrapper } from '../../../component/animation/animationWrapper';
import { useMobile } from '../../../hook/usePlatform';
import UnderLineTitle from '../../../component/underLineTitle';

const CompanyGreetings: React.FC = () => {
  const isMobile = useMobile();
  return (
    <div style={{
      height: '100%',

      flex: 1,
      paddingBlock: 16,
    }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: isMobile ? 'flex-start' : 'flex-end',
          paddingBlock: isMobile ? 0 : 80,
          paddingInline: 30,
        }}
      >
        <div
          style={{
            paddingInlineEnd: isMobile ? 0 : 30,
            paddingInlineStart: isMobile ? 0 : 150,
          }}
        >
          <HeadingLarge fontWeight={FontWeightType.w700}>
            단순한 만남을 넘어,
          </HeadingLarge>
          <HeadingLarge fontWeight={FontWeightType.w700}>
            진정으로 삶을 함께할 수 있는 인연을 찾는 여정을 돕습니다.
          </HeadingLarge>
          <div style={{ height: isMobile ? 24 : 64 }} />
          <FadeWrapper
            direction={FadeInDirectionType.rtl}
            fadeInDistance={10}
            duration={1}
            delay={0.3}
          >
            <UnderLineTitle
              title="시럽 인연"
              content={!isMobile ? `시럽 인연은 긴 시간 쌓아온 당신의 경험과 가치를 존중하며,
                                        새로운 만남을 통해 더 큰 행복과 설렘을 선사하는 
                                        프리미엄 만남을 위한 회사입니다.
                                        저희는 단순한 만남을 넘어, 진정으로 삶을 함께할 수 있는 
                                        인연을 찾는 여정을 돕습니다. 
                                        ` : `시럽 인연은 긴 시간 쌓아온 
                                        당신의 경험과 가치를 존중하며,
                                        새로운 만남을 통해 더 큰 행복과 설렘을
                                        선사하는 프리미엄 만남을 위한 회사입니다.
                                        저희는 단순한 만남을 넘어, 진정으로 삶을
                                        함께할 수 있는 인연을 찾는 여정을 돕습니다. 
                                        `}
            />
          </FadeWrapper>
          <FadeWrapper
            style={{
              marginTop: isMobile ? 33 : 66,
            }}
            direction={FadeInDirectionType.rtl}
            fadeInDistance={10}
            duration={1}
            delay={0.6}
          >
            <UnderLineTitle
              title="데이터"
              content={!isMobile
                ? `시럽은 지난 수년간 2만 건 이상의 매칭 데이터를 축적하고
                                             세밀히 분석하며, 성공적인 커플의 핵심 요소들을 파악하였습니다.
                                             이를 바탕으로 개발된 매칭 시스템은 단순한 조건 매칭을 넘어,
                                             실제 관계의 만족도를 고려한 최적의 매칭을 제공해 드립니다.
                                             우리의 데이터는 특히 50대 이상 회원님들의 성공적인
                                             만남을 위한 귀중한 통찰을 제공합니다.
                                            `
                : `시럽은 지난 수년간 2만 건 이상의
                                             매칭 데이터를 축적하고 세밀히 분석하여,
                                             성공적인 커플의 핵심 요소들을 파악했습니다.
                                                
                                             이를 바탕으로 개발된 매칭 시스템은 단순한 조건 매칭을 넘어, 실제 관계의 만족도를
                                             고려한 최적의 매칭을 제공해 드립니다.
                                                
                                             우리의 데이터는 특히 50대 이상
                                             회원님들의 성공적인 만남을 위한
                                             귀중한 통찰을 제공합니다. 
                                            `}
            />

          </FadeWrapper>
          <FadeWrapper
            style={{
              marginTop: isMobile ? 33 : 66,
            }}
            direction={FadeInDirectionType.rtl}
            fadeInDistance={10}
            duration={1}
            delay={0.9}
          >
            <UnderLineTitle
              title="프리미엄"
              content={!isMobile
                ? `시럽은 프리미엄 서비스로 차별화된 경험을 제공합니다. 
전문 커플 매니저들은 고객의 상황과 니즈를 깊이 이해하며, 
심리 상담과 관계 코칭을 포함한 세심한 맞춤형 지원을 제공합니다. 
여기에 더해, 고객 간의 신뢰를 높이고 더 나은 관계를 형성할 수 
있도록 철저한 신원 확인과 엄격한 검증 시스템을 운영합니다.
                                            `
                : `시럽은 프리미엄 서비스로 
차별화된 경험을 제공합니다. 
전문 커플 매니저들은 고객의 상황과 
니즈를 깊이 이해하며, 심리 상담과 관계 코칭을 포함한 세심한 맞춤형 지원을 제공합니다. 
여기에 더해, 고객 간의 신뢰를 높이고 더 나은 관계를 형성할 수 있도록 철저한 신원 확인과 엄격한 검증 시스템을 운영합니다.
                                            `}
            />
          </FadeWrapper>
        </div>
      </div>
    </div>
  );
};

export default CompanyGreetings;
